export default {
  fr: {
    is_promo_description:
      'est une association certifiée par Dift, voici les critères que nous évaluons :',
    title: 'Association certifiée',
    stable: 'Gestion financière',
    innovation: 'Innovation & efficience',
    ambition: 'Esprit entrepreneurial, agilité & ambition',
    gouvernance: 'Gouvernance & valeurs',
    transparency: "Transparence, suivi & mesure d'impact",
    impact: 'Impact systémique',
  },
  en: {
    is_promo_description:
      'is an association certified by Dift, here are the criteria we evaluate:',
    title: 'Certified association',
    stable: 'Financial management',
    innovation: 'Innovation & efficiency',
    ambition: 'Entrepreneurial spirit, agility & ambition',
    gouvernance: 'Governance & values',
    transparency: 'Transparency, monitoring & impact measurement',
    impact: 'Systemic impact',
  },
  'pt-br': {
    is_promo_description:
      'é uma associação certificada pela Dift, aqui estão os critérios que avaliamos:',
    title: 'Associação certificada',
    stable: 'Gestão financeira',
    innovation: 'Inovação e eficiência',
    ambition: 'Espírito empreendedor, agilidade e ambição',
    gouvernance: 'Governança e valores',
    transparency: 'Transparência, monitoramento e medição de impacto',
    impact: 'Impacto sistêmico',
  },
  es: {
    is_promo_description:
      'es una asociación certificada por Dift, estos son los criterios que evaluamos:',
    title: 'Asociación certificada',
    stable: 'Gestión financiera',
    innovation: 'Innovación y eficiencia',
    ambition: 'Espíritu emprendedor, agilidad y ambición',
    gouvernance: 'Gobernanza y valores',
    transparency: 'Transparencia, seguimiento y medición del impacto',
    impact: 'Impacto sistémico',
  },
  de: {
    is_promo_description:
      'ist ein von Dift zertifizierter Verein, hier sind die Kriterien, die wir bewerten:',
    title: 'Zertifizierter Verein',
    stable: 'Finanzmanagement',
    innovation: 'Innovation und Effizienz',
    ambition: 'Unternehmerischer Geist, Agilität und Ehrgeiz',
    gouvernance: 'Führung und Werte',
    transparency: 'Transparenz, Überwachung und Wirkungsmessung',
    impact: 'Systemische Wirkung',
  },
} as const
